import { MoveButton } from "./MoveButton";
import css from "./ModalActions.module.css";

/**
 * Sticky footer per screen-03 / screen-03b эталон.
 *
 * Two layouts switched by isNew:
 *
 *   CREATE (isNew=true):
 *     [НЕ СТАНДАРТНЫЙ СЛОТ pink]   [СОЗДАТЬ БРОНЬ/ЛИД green]
 *     [ЗАБЛОКИРОВАТЬ blue]          [ЗАКРЫТЬ ghost]
 *
 *   EDIT (isNew=false):
 *     [СОХРАНИТЬ green]             [ПЕРЕНЕСТИ purple]
 *     [ОТМЕНИТЬ БРОНЬ red]          [ЗАКРЫТЬ ghost]
 *
 * Save label (create only):
 *  - "СОЗДАТЬ БРОНЬ" when formType === "booking"
 *  - "СОЗДАТЬ ЛИД"   when formType === "lead"
 */
export interface ModalActionsProps {
  isNew: boolean;
  isBlock: boolean;
  formType: "booking" | "lead";
  saving: boolean;
  validationErr: string;
  onSave: () => void;
  /** Create-only: opens custom-time prompt. */
  onCustomTime: () => void;
  /** Create-only: opens block-reason prompt. */
  onBlock: () => void;
  /** Edit-only: opens move-slot picker. */
  onMove?: () => void;
  /** 10.09 (владелец): у заблокированного слота вместо «Перенести» — снятие блока. */
  onUnblock?: () => void;
  /** Edit-only: opens cancel-reason prompt. */
  onCancel?: () => void;
  onClose: () => void;
}

export function ModalActions({
  isNew, isBlock, formType, saving, validationErr,
  onSave, onCustomTime, onBlock, onMove, onUnblock, onCancel, onClose,
}: ModalActionsProps) {
  if (isNew) {
    const saveLabel = formType === "lead" ? "СОЗДАТЬ ЛИД" : "СОЗДАТЬ БРОНЬ";
    return (
      <div className={css.footer}>
        {validationErr ? <div className={css.err}>{validationErr}</div> : null}

        <button
          type="button"
          className={`${css.btn} ${css.btnPink} ${css.btnLong}`}
          onClick={onCustomTime}
          disabled={saving || isBlock}
        >
          НЕ СТАНДАРТНЫЙ СЛОТ
        </button>
        <button
          type="button"
          className={`${css.btn} ${css.btnPrimary}`}
          onClick={onSave}
          disabled={saving}
        >
          {saving ? "…" : saveLabel}
        </button>
        <button
          type="button"
          className={`${css.btn} ${css.btnDanger}`}
          onClick={onBlock}
          disabled={saving || isBlock}
        >
          ЗАБЛОКИРОВАТЬ
        </button>
        <button
          type="button"
          className={`${css.btn} ${css.btnGhost}`}
          onClick={onClose}
          disabled={saving}
        >
          ЗАКРЫТЬ
        </button>
      </div>
    );
  }

  /* Edit-state layout. ПЕРЕНЕСТИ button is a long-press-morph: tap = move
     to standard slot; long-press → morphs into «НЕ СТАНДАРТНЫЙ СЛОТ» pink. */
  return (
    <div className={css.footer}>
      {validationErr ? <div className={css.err}>{validationErr}</div> : null}

      <button
        type="button"
        className={`${css.btn} ${css.btnPrimary}`}
        onClick={onSave}
        disabled={saving}
      >
        {saving ? "…" : "СОХРАНИТЬ"}
      </button>
      {isBlock && onUnblock ? (
        <button type="button" className={`${css.btn} ${css.btnPurple}`} onClick={onUnblock} disabled={saving}>
          РАЗБЛОКИРОВАТЬ
        </button>
      ) : (
        <MoveButton
          onMove={onMove ?? (() => {})}
          onCustomTime={onCustomTime}
          disabled={saving || !onMove}
        />
      )}
      <button
        type="button"
        className={`${css.btn} ${css.btnRed}`}
        onClick={onCancel}
        disabled={saving || !onCancel}
      >
        ОТМЕНИТЬ БРОНЬ
      </button>
      <button
        type="button"
        className={`${css.btn} ${css.btnGhost}`}
        onClick={onClose}
        disabled={saving}
      >
        ЗАКРЫТЬ
      </button>
    </div>
  );
}
